export default "__VITE_ASSET__oU6Wqqpg__"